<template>
  <section class="mt-4">
    <image-form :element="element" :repos="repos"></image-form>
    <animation-form :element="element"></animation-form>
    <pin-form :element="element"></pin-form>
  </section>
</template>

<script>
// import Component from "../component_location"
import PinForm from "@/components/ElementForm/PinForm.vue";
import ImageForm from "@/components/ElementForm/ImageForm.vue";
import DurationForm from "@/components/ElementForm/DurationForm.vue";
import AnimationForm from "@/components/ElementForm/AnimationForm.vue";

export default {
  components: { PinForm, ImageForm, DurationForm, AnimationForm },

  props: ["element", "repos"],

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
